import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from '@app/App'
import './index.css'

const container = document.getElementById('root')
if (!container) throw new Error('Root container missing')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

/**
 * NFR-07 / R-04: ask for persistent storage.
 *
 * Browser storage eviction destroying a user's history is rated high
 * probability AND high impact, and it is worst on iOS where storage for a
 * non-installed site can be evicted after about a week of non-use. Asking is
 * cheap and is the only lever available from here; export prompts and eviction
 * detection follow in v0.4.
 */
if (navigator.storage?.persist) {
  void navigator.storage.persisted().then((already) => {
    if (!already) void navigator.storage.persist()
  })
}
